<p [innerHTML]="elementData.text"></p>